module.exports = __webpack_public_path__ + "img/invest.4683d65a.svg";